module.exports = __webpack_public_path__ + "static/img/title-en.cb44ab19.webp";